import { allManagePartnersRoutes, managePartnersBaseRoute } from '@atlassian/mpac-partners';
import React from 'react';

import NotFound from '../../../common/components/NotFound';
import CategoriesPageRouteHandler from '../pages/categories/CategoriesPageRouteHandler';
import resolveAddonDiscoveryRoutes from './components/AddonDiscoveryRoutes/components/AddonDiscoveryRoutes';
import resolveAppListingRoutes from './components/AppListingRoutes/components/AppListingRoutes';
import AtlassianSupportsUkraineRouteHandler from './components/AtlassianSupportsUkraineRoute/components/AtlassianSupportsUkraineRouteHandler';
import SolutionsRouteHandler from './components/CategoriesRoutes/components/SolutionsRouteHandler';
import resolveCollectionsRoutes from './components/CollectionsRoutes/routes/CollectionsRoutes';
import ManageAppsRouteHandler from './components/ManageAppsRoutes/components/ManageAppsRouteHandler';
import ManagePartnersRouteHandler from './components/ManagePartnersRoutes/components/ManagePartnersRouteHandler';
import resolveVendorDetailsRoutes from './components/VendorDetailsRoutes/components/VendorDetailsRoutes';

import type AddonDiscoveryConfig from '../../records/AddonDiscoveryConfig';
import type CollectionsConfig from '../../records/CollectionsConfig';
import type SolutionsConfig from '../../records/SolutionsConfig';
import type VendorDetailsConfig from '../../records/VendorDetailsConfig';
import type { AMKTRoute } from './components/Routes.types';

type GetAllRoutesArgs = {
  addonDiscoveryConfig: AddonDiscoveryConfig;
  collectionsConfig: CollectionsConfig;
  vendorDetailsConfig: VendorDetailsConfig;
  solutionsConfig: SolutionsConfig;
  flags: {
    enableAetherExperienceFlag: boolean;
  };
};

export default function getAllRoutes({
  addonDiscoveryConfig,
  collectionsConfig,
  vendorDetailsConfig,
  flags: { enableAetherExperienceFlag },
}: GetAllRoutesArgs): AMKTRoute[] {
  return [
    ...resolveAddonDiscoveryRoutes({
      addonDiscoveryConfig,
      enableAetherExperienceFlag,
    }),
    ...resolveCollectionsRoutes({
      collectionsConfig,
      enableAetherExperienceFlag,
    }),
    {
      name: 'categoriesScreen',
      path: '/categories/:categoryId',
      exact: true,
      component: enableAetherExperienceFlag ? CategoriesPageRouteHandler : SolutionsRouteHandler,
    },
    ...resolveVendorDetailsRoutes({
      vendorDetailsConfig,
    }),
    ...resolveAppListingRoutes(),
    {
      name: 'managePartnersScreen',
      path: managePartnersBaseRoute,
      component: ManagePartnersRouteHandler,
    },
    {
      name: 'ukraineSupportScreen',
      path: '/atlassian-stands-with-ukraine',
      exact: true,
      component: AtlassianSupportsUkraineRouteHandler,
    },
    {
      name: 'manageAppsScreen',
      path: '/manage/apps/:appId(\\d+)',
      component: ManageAppsRouteHandler,
    },
    {
      name: 'notFoundScreen',
      // eslint-disable-next-line react/display-name
      render: (routeProps) => (
        <NotFound {...routeProps} homeLink={addonDiscoveryConfig.links.home} />
      ),
    },
    ...allManagePartnersRoutes,
  ];
}
